import React from 'react';
import Button from 'atoms/Button/Button';
import Stack from 'atoms/Layout/Stack/Stack';
import Grid from 'atoms/Layout/Grid/Grid';
import BaseFormThankYou from 'molecules/FormHandler/BaseFormThankYou';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import HubspotFormWrapper from 'molecules/HubspotForm/HubspotFormWrapper';
import useFreeTrialHubspotFormHandler from 'src/hooks/useFreeTrialHubspotFormHandler';

const FORM_WRAPPER_ID = 'footer-free-trial-form';

const FooterFreeTrialEmailBlock = (): JSX.Element => {
  const { isLoading, isSubmitted, submitFormAndNavigate } = useFreeTrialHubspotFormHandler({
    formWrapperId: FORM_WRAPPER_ID,
    statsigEventKey: 'free_trial_email_block_footer',
  });

  return (
    <Grid
      totalColumns={1}
      background='bg-secondary'
      borderRadius='radius-2xl'
      padding='spacing-4xl'
      gap='spacing-4xl'
      dataColorMode='dark'
      maxWidth='width-xs'
      marginLeft='spacing-lg'
      marginLeftLg='spacing-none'
    >
      {isSubmitted ? (
        <BaseFormThankYou
          alignment='center'
          heading={{ color: 'text-primary-on-brand' }}
          supportingText={{
            text: "We can't wait to see what you build.",
            color: 'text-primary-on-brand',
          }}
        />
      ) : (
        <>
          <HeadingAndSupportingText
            heading={{
              type: 'heading',
              as: 'p',
              size: 'sm',
              fontWeight: 'font-weight-semibold',
              text: 'Start your free trial',
              color: 'text-primary-on-brand',
            }}
            supportingText={{
              type: 'paragraph',
              color: 'brand-500',
              size: 'lg',
              fontWeight: 'font-weight-medium',
              text: '14 Days. No Credit Card Required.',
            }}
            gap='spacing-xs'
          />
          <Stack
            direction='column'
            gap='spacing-xl'
          >
            <Stack dataColorMode='light'>
              <HubspotFormWrapper
                id={FORM_WRAPPER_ID}
                hideInputLabels
                hideLegal
              />
            </Stack>
            <Button
              variant='primary'
              size='xl'
              onClick={submitFormAndNavigate}
              disabled={isLoading}
            >
              Try Mighty for Free
            </Button>
          </Stack>
        </>
      )}
    </Grid>
  );
};

export default FooterFreeTrialEmailBlock;
